<template>
    <div class="flex flex-1 flex-row flex-wrap items-center justify-end content-end cursor-pointer whitespace-no-wrap">
        <div @click="addToCart" class="hidden lg:block ml-5 my-2">{{ addCartBtnText }}</div>
        <div class="ml-5">
            <div @click="addToCartAndCheckout" class="btn--red">Buy now</div>
        </div>
    </div>
</template>

<script>

import { cart, mutations } from "./cart";


export default {
    name: "button-to-add-to-cart",
    data: function () {
        return {
            addCartBtnText: '+ Add to cart',
            cart: cart,
        }
    },
    props: {
        product: {
            type: Object,
            default: {},
        }
    },
    methods: {
        addToCart() {
            mutations.addItem(this.product.id)
            // this.addCartBtnText = 'Added to cart'
            this.addCartBtnText = 'Product added'

            // axios.post('/cart/add/'+this.product.id, {quantity: 1})
            //     .then(response => {
            //         cart.update(response.data.cart, response.data.totals)
            //     })
            //     .catch((err) => {
            //         console.log(err)
            //     });
        },
        addToCartAndCheckout() {
            mutations.addItem(this.product.id)
            window.location.href = '/checkout';
        }
    },
}
</script>
